import script from "./WHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WHeader.vue?vue&type=script&setup=true&lang=ts"

import "./WHeader.vue?vue&type=style&index=0&id=1b168e3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b168e3c"]])

export default __exports__